var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"main"}},[_c('Header'),_vm._v(" "),_c('div',{staticClass:"page-container"},[_c('div',{staticClass:"content-wrapper"},[_c('router-view')],1),_vm._v(" "),_c('Footer'),_vm._v(" "),_c('Sidebar')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c776791e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Home.vue
// module id = 288
// module chunks = 0